<div class="dialog-container">
  <h2>{{ isEditMode ? 'Edit DCO' : 'Add DCO' }}</h2>

  <!-- Content Section -->
  <div class="dialog-content">
    <form [formGroup]="form">
      <!-- Name Field -->
      <mat-form-field appearance="fill">
        <mat-label>Name</mat-label>
        <input matInput id="name" formControlName="nameFormControl" readonly />
        <mat-error *ngIf="nameFormControl.invalid && nameFormControl.touched">
          Name is required.
        </mat-error>
      </mat-form-field>

      <!-- Display Name -->
      <mat-form-field appearance="fill">
        <mat-label>Display Name</mat-label>
        <textarea matInput id="displayName" formControlName="displayNameFormControl"></textarea>
      </mat-form-field>

      <!-- Description Field -->
      <mat-form-field appearance="fill">
        <mat-label>Description</mat-label>
        <textarea matInput id="description" formControlName="descriptionFormControl"></textarea>
      </mat-form-field>

      <!-- Notification Email Field -->
      <mat-form-field appearance="fill">
        <mat-label>Notification Email</mat-label>
        <input matInput id="notificationEmail" formControlName="notificationEmailFormControl" type="email" />
      </mat-form-field>

      <!-- Active Checkbox -->
      <mat-checkbox formControlName="activeFormControl">Active</mat-checkbox>
      <mat-error *ngIf="activeFormControl.invalid && activeFormControl.touched">
        Active status is required.
      </mat-error>
    </form>
  </div>

  <!-- Action Buttons -->
  <div class="dialog-actions">
    <button mat-button (click)="onClose()" class="close-button">Close</button>
    <button mat-raised-button color="primary" (click)="onSave()" class="save-button" [disabled]="form.invalid">Save</button>
  </div>
</div>
